import PropTypes from 'prop-types';
import CustomTextInput from '../atoms/custom-text-input.atom';
import CustomSelect from '../atoms/custom-select.atom';

const AddressInfoForm = ({
    isLoading,
    errors = {},
    zipCode,
    onZipCodeChange,
    neighborhoodOptions,
    neighborhood,
    onNeighborhoodChange,
    street,
    onStreetChange,
    externalNumber,
    onExternalNumberChange,
    internalNumber,
    onInternalNumberChange

}) => {
    return (
        <div style={styles.container}>
            <CustomTextInput
                label="Código postal"
                placeholder="Código postal"
                value={zipCode}
                onChange={onZipCodeChange}
                maxLength={5}
                disabled={isLoading}
                inputContainerStyle={neighborhoodOptions?.length === 0 ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                error={errors.zipCode}
                id="zipCode"
            />
            <CustomSelect
                disabled={!!errors.zipCode || !neighborhoodOptions || neighborhoodOptions?.length === 0}
                label="Colonia"
                placeholder="Colonia"
                value={neighborhood}
                options={neighborhoodOptions}
                inputContainerStyle={neighborhoodOptions?.length > 0 ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                onChange={onNeighborhoodChange}
                additionalInputProps={{id: 'neighborhood-input'}}
            />
            <CustomTextInput
                label="Calle"
                disabled={!neighborhood}
                placeholder="Calle"
                inputContainerStyle={neighborhood ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                value={street}
                onChange={onStreetChange}
                id="address-line-1-input"
            />
            <CustomTextInput
                label="Número exterior"
                disabled={!neighborhood}
                placeholder="Número de exterior"
                value={externalNumber}
                inputContainerStyle={neighborhood ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                onChange={onExternalNumberChange}
                id="ext-number-input"
            />
            <CustomTextInput
                disabled={!neighborhood}
                label="Número interior"
                placeholder="Número de interior"
                value={internalNumber}
                helper="Opcional"
                onChange={onInternalNumberChange}
                id="int-number-input"
            />
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%'
    }
};

AddressInfoForm.propTypes = {
    errors: PropTypes.shape({
        zipCode: PropTypes.string
    }),
    zipCode: PropTypes.string.isRequired,
    onZipCodeChange: PropTypes.func.isRequired,
    neighborhoodOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired
    })).isRequired,
    neighborhood: PropTypes.any,
    onNeighborhoodChange: PropTypes.func.isRequired,
    street: PropTypes.string,
    onStreetChange: PropTypes.func.isRequired,
    externalNumber: PropTypes.string,
    onExternalNumberChange: PropTypes.func.isRequired,
    internalNumber: PropTypes.string,
    onInternalNumberChange: PropTypes.func.isRequired
};

export default AddressInfoForm;
